import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolContact } from '../../../features/tooling/models/tool-contact.model';
import { CONTACT_TYPE_LABEL } from '../../utilities/mappers/contact-type.mappers';

@Component({
  selector: 'contacts-block',
  imports: [CommonModule],
  templateUrl: './contacts-block.component.html',
  styleUrls: ['./contacts-block.component.scss']
})

export class ContactsBlockComponent {
  contacts = input<ToolContact[]>([]);

  readonly normalizedContacts = computed(() =>
    (this.contacts() ?? []).map((contact) => ({
      ...contact,
      type: CONTACT_TYPE_LABEL[contact.type] ?? String(contact.type)
    }))
  );
}
